<template>
  <div id="app">
    <div id="logo">
      <img alt="Vue logo" src="./assets/ITSI Portal.png">
    </div>
      <portal msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
import portal from './components/portal.vue'

export default {
  name: 'app',
  components: {
    portal
  }
}
</script>

<style>
#logo {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: white;
  padding: 11px 30px 11px 10px;
}

#logo img {
  max-width: 210px;
}

</style>
